var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1000px",
    height: "1000px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#B9B9B9",
    d: "M333.116,70.484c91.787,0,241.984,0,333.77,0h219.297c91.786,0,129.335,65.038,83.442,144.526 L859.974,404.928c-45.894,79.489-120.991,209.564-166.885,289.055L583.442,883.898c-45.894,79.489-120.99,79.489-166.882,0 L306.917,693.984c-45.892-79.491-120.99-209.565-166.885-289.055L30.376,215.009c-45.895-79.488-8.347-144.525,83.44-144.525 H333.116L333.116,70.484z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDropdown);
export default __webpack_public_path__ + "static/media/icon-dropdown.96ba053cb97ac6634fab4dc41fa2b8f6.svg";
export { ForwardRef as ReactComponent };